(ns frontend.view.grid.sales-opportunities-grid.columns)


(def not-available
  #{:common/attachments
    :role/guest-buy-side
    :sales-opportunity/ratings})

;;default set of selected columns
(def ordered-default-columns
  [:sales-opportunity/name
   :sales-opportunity/next-steps
   :sales-opportunity/stage
   :sales-opportunity/status
   :sales-opportunity/probability-percentage
   :sales-opportunity/owner])

(def default-columns
  (set ordered-default-columns))

;;always selected:
(def mandatory?
  #{:sales-opportunity/name})

(def my-sales-opportunities-ordered-columns
  [:sales-opportunity/name
   :sales-opportunity/next-steps
   :sales-opportunity/stage
   :sales-opportunity/status
   :sales-opportunity/probability-category])

(def my-sales-opportunities-columns
  (set my-sales-opportunities-ordered-columns))

(def lost-sales-opportunities-ordered-columns
  [:sales-opportunity/name
   :sales-opportunity/stage
   :sales-opportunity/lost-reason
   :sales-opportunity/lost-comment
   :sales-opportunity/lost-on
   :sales-opportunity/owner])

(def lost-sales-opportunities-columns
  (set lost-sales-opportunities-ordered-columns))

(def sales-opportunities-on-hold-ordered-columns
  [:sales-opportunity/name
   :sales-opportunity/next-steps
   :sales-opportunity/stage
   :sales-opportunity/on-hold-comment
   :sales-opportunity/put-on-hold-on
   :sales-opportunity/on-hold-until
   :sales-opportunity/owner])

(def sales-opportunities-on-hold-columns
  (set sales-opportunities-on-hold-ordered-columns))
